/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/*
* Display metadata popup window
*/
import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Modal from 'react-modal';

Modal.setAppElement('#popup');

export class MetadataPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.currentMetadataSet !== prevState.item) {
            return {
                item: {
                    ...nextProps.currentMetadataSet,
                    unscrubbed: nextProps.currentMetadataSet.unscrubbed  ? "True" : "False"
                }
            };
        }
    }

    render() {
        const rows = Object.entries(this.state.item).sort().map((data, index) =>
            <div key={index} className="pe-row metadataRow">
                <div className='row-key pe-col-4' >
                    {data[0]} :
                </div>
                <div className='pe-col-6'>
                    {data[1]}
                </div>
            </div>
        );
        const customStyles = {
            overlay: {zIndex: 10}
        };
        return (
            <Modal className="Modal" overlayClassName="Overlay" isOpen={true} style={customStyles} onRequestClose={() => {
                this.props.closePopup();
            }}>
                <div className='popup'>
                    <div className='popup_inner'>
                        <div className='popup-header'>
                            <div className='pe-col-9 header-text'>
                                <h1>{this.props.text}</h1>
                            </div>
                            <div className='pe-col-3 close-button'>
                                <button className='pe-btn close' onClick={this.props.closePopup}>x</button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <Scrollbars
                                renderTrackHorizontal={props => <div {...props} style={{ display: 'none' }} className="track-horizontal" />} >
                                <div className="popup-table">
                                    {rows}
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/MetadataPopupComponent.js